import NewsTable from './NewsTable';

export default NewsTable;
